<template>
    <div class="page-content page-code-add">
        <PageHeader title="代码位管理"/>
        <div class="page-scroll-box">
            <div>
                <el-button type="text" icon="el-icon-arrow-left" class="btn-back" @click="goBack">返回</el-button>
            </div>
            <Info v-if="activeType === 1" :codeType="activeType"/>
            <Coopen v-else-if="activeType === 2" :codeType="activeType"/>
            <Video v-else-if="activeType === 3" :codeType="activeType"/>
            <Screen v-else-if="activeType === 4" :codeType="activeType"/>
            <!--<Suspend v-else-if="activeType === 5" :codeType="activeType"/>-->
            <NewScreen v-else-if="activeType === 7" :codeType="activeType"/>
            <div v-else class="type-box">
                <i
                    v-for="item in adslotTypeOptions"
                    :key="item.key"
                    :class="`type-item ${item.icon}`"
                    @click="() => goAdd(item)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import {getCodeTypeList} from '@/apis/flow.js';
import Info from './modules/info.vue'
import Coopen from './modules/coopen.vue'
import Video from './modules/video.vue'
import Screen from './modules/screen.vue'
import NewScreen from './modules/newscreen.vue'
// import Suspend from './modules/suspend.vue'

export default {
    data() {
        return {
            activeType: '',
            adslotTypeOptions: []
        }
    },
    components: {
        PageHeader,
        Info,
        Coopen,
        Video,
        Screen,
        NewScreen,
        // Suspend
    },
    created() {
        this.activeType = this.type
        !this.activeType && this.getCodeTypeList()
    },
    computed: {
        id() {
            return this.$route.query.id || ''
        },
        type() {
            return +this.$route.query.type || ''
        }
    },
    methods: {
        async getCodeTypeList() {
            const map = {
                1: {
                    key: 'info',
                    icon: 'icon-info'
                },
                2: {
                    key: 'coopen',
                    icon: 'icon-coopen'
                },
                3: {
                    key: 'video',
                    icon: 'icon-video'
                },
                4: {
                    key: 'screen',
                    icon: 'icon-screen'
                },
                // 5: {
                //     key: 'suspend',
                //     icon: 'icon-suspend'
                // },
                7: {
                    key: 'newscreen',
                    icon: 'icon-new-screen'
                },
            }
            const {data = {}} = await getCodeTypeList();
            const options = [
                ...(data.options || [])
            ]
            this.adslotTypeOptions = options.map(item => {
                return {
                    ...item,
                    ...(map[item.value] || {})
                }
            })
        },
        goBack() {
            if (this.activeType && this.activeType !== this.type) {
                this.activeType = ''
            } else {
                this.$router.go(-1)
            }
        },
        goAdd(item) {
            this.activeType = item.value
        }
    }
}
</script>
<style lang="scss">
@import "~@/assets/css/form.scss";
</style>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";
@import "~@/assets/css/form.scss";

.page-code-add {
    .btn-back {
        margin-bottom: 32px;
        padding: 0;
    }
    
    .type-box {
        display: flex;
        flex-wrap: wrap;
        
        .type-item {
            margin-right: 30px;
            margin-bottom: 30px;
            display: inline-block;
            width: 162px;
            height: 210px;
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            
            &:last-child {
                margin-right: 0;
            }
            
            &.icon-info {
                background-image: url('./images/information_flow.png');
            }
            
            &.icon-coopen {
                background-image: url('./images/coopen.png');
            }
            
            &.icon-video {
                background-image: url('./images/video.png');
            }
            
            &.icon-screen {
                background-image: url('./images/screen.png');
            }
            
            //&.icon-suspend {
            //    background-image: url('./images/suspend.png');
            //}
            
            &.icon-new-screen {
                background-image: url('./images/newscreen.png');
            }
        }
    }
}
</style>
